import { render, staticRenderFns } from "./ListTabs.vue?vue&type=template&id=35d37702&scoped=true"
import script from "./ListTabs.vue?vue&type=script&lang=js"
export * from "./ListTabs.vue?vue&type=script&lang=js"
import style0 from "./ListTabs.vue?vue&type=style&index=0&id=35d37702&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d37702",
  null
  
)

export default component.exports